import { AsYouType, getCountries, getCountryCallingCode } from 'libphonenumber-js';
import mobileExamples from 'libphonenumber-js/mobile/examples';
const EXAMPLES_BY_COUNTRY = mobileExamples;
const DISPLAY_NAME_OVERRIDES = {
    GB: 'United Kingdom',
};
const FORMAT_OVERRIDES = {
    US: '+X (XXX) XXX-XXXX',
    CA: '+X (XXX) XXX-XXXX',
};
const regionDisplayNames = typeof Intl !== 'undefined' && 'DisplayNames' in Intl ? new Intl.DisplayNames(['en'], { type: 'region' }) : null;
const toFlagEmoji = (countryCode) => {
    return countryCode
        .toUpperCase()
        .split('')
        .map((char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        .join('');
};
const toFormatTemplate = (callingCode, exampleNationalNumber, country) => {
    const override = FORMAT_OVERRIDES[country];
    if (override) {
        return override;
    }
    const exampleE164 = `+${callingCode}${exampleNationalNumber}`;
    const formatted = new AsYouType().input(exampleE164);
    return formatted.replace(/\d/g, 'X');
};
const byCountryCode = new Map();
const byCallingCode = new Map();
for (const country of getCountries()) {
    const callingCode = getCountryCallingCode(country);
    const exampleNationalNumber = EXAMPLES_BY_COUNTRY[country] || '';
    const displayName = DISPLAY_NAME_OVERRIDES[country] || regionDisplayNames?.of(country) || country;
    const metadata = {
        code: country,
        displayName,
        flag: toFlagEmoji(country),
        callingCode,
        maxNationalDigits: exampleNationalNumber.length || 15 - callingCode.length,
        formatTemplate: toFormatTemplate(callingCode, exampleNationalNumber, country),
    };
    byCountryCode.set(country, metadata);
    const list = byCallingCode.get(callingCode) || [];
    list.push(metadata);
    byCallingCode.set(callingCode, list);
}
const sortByCallingCodeLength = (a, b) => b.length - a.length;
export const KNOWN_CALLING_CODES = Array.from(byCallingCode.keys()).sort(sortByCallingCodeLength);
const PRIORITY_BY_CALLING_CODE = {
    '1': 'US',
    '44': 'GB',
};
export const getCountryMetadataByCountryCode = (countryCode) => {
    return byCountryCode.get(countryCode) || null;
};
export const getCountryMetadataByCallingCode = (callingCode) => {
    const countries = byCallingCode.get(callingCode);
    if (!countries || countries.length === 0) {
        return null;
    }
    const prioritizedCountry = PRIORITY_BY_CALLING_CODE[callingCode];
    if (prioritizedCountry) {
        const prioritizedMetadata = byCountryCode.get(prioritizedCountry);
        if (prioritizedMetadata) {
            return prioritizedMetadata;
        }
    }
    return countries[0];
};
